import _toConsumableArray from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { isArray } from 'vega-util';
import { isBinning } from '../../bin';
import { COLUMN, FACET_CHANNELS, ROW } from '../../channel';
import { vgField } from '../../channeldef';
import * as log from '../../log';
import { hasDiscreteDomain } from '../../scale';
import { DEFAULT_SORT_OP, isSortField } from '../../sort';
import { hash as _hash } from '../../util';
import { isVgRangeStep } from '../../vega.schema';
import { HEADER_CHANNELS, HEADER_TYPES } from '../header/component';
import { assembleDomain, getFieldFromDomain } from '../scale/domain';
import { sortArrayIndexField } from './calculate';
import { DataFlowNode } from './dataflow';
/**
 * A node that helps us track what fields we are faceting by.
 */

export var FacetNode =
/*#__PURE__*/
function (_DataFlowNode) {
  _inherits(FacetNode, _DataFlowNode);

  /**
   * @param model The facet model.
   * @param name The name that this facet source will have.
   * @param data The source data for this facet data.
   */
  function FacetNode(parent, model, name, data) {
    var _this;

    _classCallCheck(this, FacetNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FacetNode).call(this, parent));
    _this.model = model;
    _this.name = name;
    _this.data = data;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = FACET_CHANNELS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var channel = _step.value;
        var fieldDef = model.facet[channel];

        if (fieldDef) {
          var bin = fieldDef.bin,
              sort = fieldDef.sort;
          _this[channel] = Object.assign({
            name: model.getName("".concat(channel, "_domain")),
            fields: [vgField(fieldDef)].concat(_toConsumableArray(isBinning(bin) ? [vgField(fieldDef, {
              binSuffix: 'end'
            })] : []))
          }, isSortField(sort) ? {
            sortField: sort
          } : isArray(sort) ? {
            sortIndexField: sortArrayIndexField(fieldDef, channel)
          } : {});
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    _this.childModel = model.child;
    return _this;
  }

  _createClass(FacetNode, [{
    key: "hash",
    value: function hash() {
      var out = "Facet";
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = FACET_CHANNELS[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var channel = _step2.value;

          if (this[channel]) {
            out += " ".concat(channel.charAt(0), ":").concat(_hash(this[channel]));
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return out;
    }
  }, {
    key: "getSource",

    /**
     * The name to reference this source is its name.
     */
    value: function getSource() {
      return this.name;
    }
  }, {
    key: "getChildIndependentFieldsWithStep",
    value: function getChildIndependentFieldsWithStep() {
      var childIndependentFieldsWithStep = {};

      for (var _i = 0, _arr = ['x', 'y']; _i < _arr.length; _i++) {
        var channel = _arr[_i];
        var childScaleComponent = this.childModel.component.scales[channel];

        if (childScaleComponent && !childScaleComponent.merged) {
          // independent scale
          var type = childScaleComponent.get('type');
          var range = childScaleComponent.get('range');

          if (hasDiscreteDomain(type) && isVgRangeStep(range)) {
            var domain = assembleDomain(this.childModel, channel);
            var field = getFieldFromDomain(domain);

            if (field) {
              childIndependentFieldsWithStep[channel] = field;
            } else {
              log.warn('Unknown field for ${channel}.  Cannot calculate view size.');
            }
          }
        }
      }

      return childIndependentFieldsWithStep;
    }
  }, {
    key: "assembleRowColumnHeaderData",
    value: function assembleRowColumnHeaderData(channel, crossedDataName, childIndependentFieldsWithStep) {
      var childChannel = {
        row: 'y',
        column: 'x'
      }[channel];
      var fields = [];
      var ops = [];
      var as = [];

      if (childIndependentFieldsWithStep && childIndependentFieldsWithStep[childChannel]) {
        if (crossedDataName) {
          // If there is a crossed data, calculate max
          fields.push("distinct_".concat(childIndependentFieldsWithStep[childChannel]));
          ops.push('max');
        } else {
          // If there is no crossed data, just calculate distinct
          fields.push(childIndependentFieldsWithStep[childChannel]);
          ops.push('distinct');
        } // Although it is technically a max, just name it distinct so it's easier to refer to it


        as.push("distinct_".concat(childIndependentFieldsWithStep[childChannel]));
      }

      var _this$channel = this[channel],
          sortField = _this$channel.sortField,
          sortIndexField = _this$channel.sortIndexField;

      if (sortField) {
        var _sortField$op = sortField.op,
            op = _sortField$op === void 0 ? DEFAULT_SORT_OP : _sortField$op,
            field = sortField.field;
        fields.push(field);
        ops.push(op);
        as.push(vgField(sortField, {
          forAs: true
        }));
      } else if (sortIndexField) {
        fields.push(sortIndexField);
        ops.push('max');
        as.push(sortIndexField);
      }

      return {
        name: this[channel].name,
        // Use data from the crossed one if it exist
        source: crossedDataName || this.data,
        transform: [Object.assign({
          type: 'aggregate',
          groupby: this[channel].fields
        }, fields.length ? {
          fields: fields,
          ops: ops,
          as: as
        } : {})]
      };
    }
  }, {
    key: "assembleFacetHeaderData",
    value: function assembleFacetHeaderData(childIndependentFieldsWithStep) {
      var columns = this.model.layout.columns;
      var layoutHeaders = this.model.component.layoutHeaders;
      var data = [];
      var hasSharedAxis = {};
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = HEADER_CHANNELS[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var headerChannel = _step3.value;
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = HEADER_TYPES[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var headerType = _step4.value;
              var headers = layoutHeaders[headerChannel] && layoutHeaders[headerChannel][headerType] || [];
              var _iteratorNormalCompletion5 = true;
              var _didIteratorError5 = false;
              var _iteratorError5 = undefined;

              try {
                for (var _iterator5 = headers[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                  var header = _step5.value;

                  if (header.axes && header.axes.length > 0) {
                    hasSharedAxis[headerChannel] = true;
                    break;
                  }
                }
              } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                    _iterator5.return();
                  }
                } finally {
                  if (_didIteratorError5) {
                    throw _iteratorError5;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }

          if (hasSharedAxis[headerChannel]) {
            var cardinality = "length(data(\"".concat(this.facet.name, "\"))");
            var stop = headerChannel === 'row' ? columns ? {
              signal: "ceil(".concat(cardinality, " / ").concat(columns, ")")
            } : 1 : columns ? {
              signal: "min(".concat(cardinality, ", ").concat(columns, ")")
            } : {
              signal: cardinality
            };
            data.push({
              name: "".concat(this.facet.name, "_").concat(headerChannel),
              transform: [{
                type: 'sequence',
                start: 0,
                stop: stop
              }]
            });
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var row = hasSharedAxis.row,
          column = hasSharedAxis.column;

      if (row || column) {
        data.unshift(this.assembleRowColumnHeaderData('facet', null, childIndependentFieldsWithStep));
      }

      return data;
    }
  }, {
    key: "assemble",
    value: function assemble() {
      var data = [];
      var crossedDataName = null;
      var childIndependentFieldsWithStep = this.getChildIndependentFieldsWithStep();
      var column = this.column,
          row = this.row,
          facet = this.facet;

      if (column && row && (childIndependentFieldsWithStep.x || childIndependentFieldsWithStep.y)) {
        // Need to create a cross dataset to correctly calculate cardinality
        crossedDataName = "cross_".concat(this.column.name, "_").concat(this.row.name);
        var fields = [].concat(childIndependentFieldsWithStep.x || [], childIndependentFieldsWithStep.y || []);
        var ops = fields.map(function () {
          return 'distinct';
        });
        data.push({
          name: crossedDataName,
          source: this.data,
          transform: [{
            type: 'aggregate',
            groupby: this.fields,
            fields: fields,
            ops: ops
          }]
        });
      }

      for (var _i2 = 0, _arr2 = [COLUMN, ROW]; _i2 < _arr2.length; _i2++) {
        var channel = _arr2[_i2];

        if (this[channel]) {
          data.push(this.assembleRowColumnHeaderData(channel, crossedDataName, childIndependentFieldsWithStep));
        }
      }

      if (facet) {
        var facetData = this.assembleFacetHeaderData(childIndependentFieldsWithStep);

        if (facetData) {
          data.push.apply(data, _toConsumableArray(facetData));
        }
      }

      return data;
    }
  }, {
    key: "fields",
    get: function get() {
      var f = [];
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = FACET_CHANNELS[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var channel = _step6.value;

          if (this[channel] && this[channel].fields) {
            f.push.apply(f, _toConsumableArray(this[channel].fields));
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      return f;
    }
  }]);

  return FacetNode;
}(DataFlowNode);